import React from 'react';

import i18n from '@client/utils/i18n';
import { ProjectDoc } from '@ledium/types';
import { ItemList } from '@ledium/ui-common';

type ProjectItem = ProjectDoc & { id: string };

const ProjectEditorMainMenu = () => {
    function isLocked(project: ProjectItem) {
        if (project.locked?.reason) {
            if (project.locked.reason === 'RUNNING_PROJECT') {
                return i18n('project_running_lock') as string;
            }
        }
        return false as const;
    }

    return <ItemList<ProjectItem> isLocked={isLocked} />;
};

export default ProjectEditorMainMenu;
